import { combineReducers } from '@reduxjs/toolkit'
import authReducers from './authReducers'
import settingsReducers from './settingsReducers'
import colorReducers from './colorReducers'
import paginationReducers from './paginationReducers'
import inspectionReducers from './inspectionReducers'

const rootReducer = combineReducers({
  auth: authReducers,
  settings: settingsReducers,
  color: colorReducers,
  pagination: paginationReducers,
  inspection: inspectionReducers
})

export default rootReducer